const appConfig = {
  carouselInterval: 3000,
}

export default appConfig